/* eslint-disable no-unused-vars */
// @flow
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { CSVLink } from 'react-csv';
import debounce from 'lodash.debounce';
import SimpleReactValidator from 'simple-react-validator';
import {
  Card,
  Table,
  Row,
  Col,
  Tooltip,
  Badge,
  Input,
  Select,
  Checkbox,
  Icon,
  Divider,
  Radio,
} from 'antd';
import {
  validators,
} from 'utils/validationMessages';
import {
  SpButton,
  FilterWrapper,
  SpText,
  SpH5,
  SpError,
} from 'components/DesignKit';
import getFrequency from 'utils/getFrequency';
import getBillingFrequency from 'utils/getBillingFrequency';
import getFilterOperators from 'utils/getFilterOperators';
import Filters from 'components/Filters';
import formatAmount from 'utils/formatAmount';
import formatNumber from 'utils/formatNumber';
import getDiscountOff from 'utils/getDiscountOff';
import getTaxAmount from 'utils/getTaxAmount';

import Loading from 'components/Loading';

import {
  planv2Actions,
  filterParamsActions,
  invoiceDetailsAction,
  inventoryItemsActions,
  inventoryPrinterLabelActions,
} from 'store/actions';
import { FILTERS_SPECS } from 'store/actionTypes';
import {
  PAGES,
  ROLES,
  FILTERS_TYPES,
  MAX_AMOUNT,
  RATE_TYPES,
  COUNTRIES,
} from 'appconstants';

import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import moment from 'moment-timezone';
import RBAC from 'components/rbac';
import SelectShippingFee from 'routes/Invoices/components/NewInvoice/SelectShippingFee';
import FilterIcon from 'components/NavIcons/filterIcon';
import ExportIcon from 'components/NavIcons/exportIcon';
import AddPlan from './components/AddPlan';
import SelectCoupon from './components/SelectCoupon';
import AddCoupon from './components/AddNewCoupon';
import SelectTaxrate from './components/SelectTaxrate';
import AddTaxrate from './components/AddNewTax';
import AddNewProduct from './components/AddNewProduct';
import AddItem from '../../../InventoryOrders/components/ItemsList/components/AddNewItem';

const { Option } = Select;

const MOMENT_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
const PLAN_FILTERS_TYPES = FILTERS_TYPES.SUB_PLAN;

type Props = {
  plans: Array<Object>,
  fetchPlanV2: Function,
  addPlanV2: Function,
  selectedAccount: Object,
  totalElements: number,
  test: boolean,
  loading: boolean,
  submitting: boolean,
  validator: boolean,
  history: {
    push: Function,
  },
  setFilterData: Function,
  preserveFilters: Object,
  getProductsList: Function,
  productsList: Array<Object>,
  fetchInventoryItems: Function,
  inventoryItems: Array<Object>,
  addNewCoupon: Function,
  customerResult: Array<Object>,
  getCustomersList: Function,
  addNewTaxRate: Function,
  newTaxrate: Object,
  taxList: Array<Object>,
  getTaxes: Function,
  addNewProcut: Function,
  fetchPrinterLabelList: Function,
  fetchModifierItemsList: Function,
  itemsList: Array<Object>,
  modifierItemsList: Array<Object>,
  labelList: Array,
  fetchItemsList: Function,
  addedNewProduct: Object,
  addedNewItem:Object,
  addInventoryItems: Function,
};

const Plans = (props: Props) => {
  const location = useLocation();
  const {
    selectedAccount,
    plans,
    loading,
    addPlanV2,
    fetchPlanV2,
    totalElements,
    submitting,
    validator,
    test,
    history,
    setFilterData,
    preserveFilters,
    getProductsList,
    productsList,
    fetchInventoryItems,
    inventoryItems,
    addNewCoupon,
    customerResult,
    getCustomersList,
    addNewTaxRate,
    newTaxrate,
    taxList,
    getTaxes,
    addNewProcut,
    fetchModifierItemsList,
    fetchPrinterLabelList,
    itemsList,
    modifierItemsList,
    labelList,
    fetchItemsList,
    addedNewProduct,
    addedNewItem,
    addInventoryItems,
  } = props;

  const [pagination, setPagination] = useState({});
  const [addPlansModal, setAddPlansModal] = useState(false);
  const [planName, setPlanName] = useState('');
  const myRef = useRef();
  const { pathname } = location;
  const [open, setOpen] = useState(false);
  const [filterTypes, setFilterTypes] = useState(PLAN_FILTERS_TYPES);
  const [fiterOperators, setFilterOperators] = useState([]);
  const [filterPlans, setFilterPlan] = useState((preserveFilters && preserveFilters.filterPlans)
    ? (preserveFilters && preserveFilters.filterPlans)
    : [{
      filterType: '',
      filterName: '',
      filterOperator: '',
      filterValue: '',
      filterNameDisplay: '',
      filterValueFrom: '',
      filterValueTo: '',
      checked: true,
    }]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [currentDate, setCurrentDate] = useState('');
  const [count, setCount] = useState(null);
  const [fillColor, setFillColor] = useState(false);
  const [filterColor, setFilterColor] = useState(false);
  const preserveParam = ((preserveFilters && preserveFilters.pathname) === pathname)
    ? queryString.parse(preserveFilters.search)
    : setFilterData({
      pathname,
      search: '',
      filterPlans: [{
        filterType: '',
        filterName: '',
        filterOperator: '',
        filterValue: '',
        filterNameDisplay: '',
        filterValueFrom: '',
        filterValueTo: '',
        checked: true,
      }],
    });
  const supportedCurrency = (selectedAccount && selectedAccount.supportedCurrencies);
  const STRING_LENGTH = 5;
  const isIndia = (selectedAccount && selectedAccount.country && selectedAccount.country.id) === COUNTRIES.INDIA.id;
  const [, forceUpdate] = useState();
  const [count1, setCount1] = useState(null);
  const [notify, setNotify] = useState('');
  const [period, setPeriod] = useState('');
  const [frequency, setFrequency] = useState('');
  const { prefix } = selectedAccount && selectedAccount.currency;
  const [allSelectedTaxrates, setAllSelectedTaxrates] = useState([]);
  const currencyObj = selectedAccount && selectedAccount.currency;
  const [totalAmount, setTotalAmount] = useState(null);
  const [updatedCoupon, setUpdatedCoupon] = useState({});
  const [description, setDescription] = useState('');
  const [lineItemDtoList, setLineItemDtosList] = useState([{
    amount: 0,
    rate: 0,
    productGid: '',
    currencyCode: '',
    description: '',
    name: '',
    note: '',
    quantity: '1',
    recurring: false,
    itemGid: '',
    priceType: '',
  }]);
  const [upFrontError, setUpFrontError] = useState(null);
  const [lineItemIndex, setLineItemIndex] = useState(null);
  const [shippingAmount, setShippingAmount] = useState(null);
  const [selectCouponModal, setSelectCouponModal] = useState(false);
  const [addCouponModal, setAddCouponModal] = useState(false);
  const currencyCode = selectedAccount?.currency?.name;
  const [customerList, setCustomerList] = useState(customerResult);
  const [selectTaxrateModal, setSelectTaxrateModal] = useState(false);
  const [taxRedirect, setTaxRedirect] = useState(false);
  const [addTaxModal, setAddTaxModal] = useState(false);
  const [allTaxes, setAllTaxes] = useState(taxList);
  const [selectShippingFeeModal, setSelectedShippingFeeModal] = useState(false);
  const [addProductModal, setAddProductModal] = useState(false);
  const [delayStartDate, setDelayStartDate] = useState(null);
  const [freeTrialDays, setFreeTrialDays] = useState(null);
  const [feesType, setFeesType] = useState('PERCENT');
  const [overdueFee, setOverdueFee] = useState(null);
  const [limitPaymentMethods, setLimitPaymentMethods] = useState(null);
  const [allowManualPayment, setAllowManualPayment] = useState(false);
  const [nextAttempt, setNextAttempt] = useState(null);
  const [addToPlanManager, setAddToPlanManager] = useState(false);
  const [pauseType, setPauseType] = useState('');
  const [redirect, setRedirect] = useState(false);
  const [addItemModal, setAddItemModal] = useState(false);
  const [addedProduct, setAddedProduct] = useState(false);
  const [addedItem, setAddedItem] = useState(false);
  const [disableDelay, setDisableDelay] = useState(false);
  const [disableFree, setDisableFree] = useState(false);
  const [surCharge, setSurCharge] = useState(null);

  const simpleValidator = useRef(new SimpleReactValidator({
    validators: {
      stringLength: {
        message: validators.paymentLink.validName,
        rule: val => val.length >= STRING_LENGTH,
      },
      amount: {
        message: isIndia ? MAX_AMOUNT.MESSAGE_INR : MAX_AMOUNT.MESSAGE_USD,
        rule: (val) => (
          isIndia ? MAX_AMOUNT.LIMIT_INR_MIN <= Number(val && val.replace(/,/g, '')) && Number(val && val.replace(/,/g, '')) <= MAX_AMOUNT.LIMIT_INR
            : MAX_AMOUNT.LIMIT_USD_MIN <= Number(val && val.replace(/,/g, '')) && Number(val && val.replace(/,/g, '')) <= MAX_AMOUNT.LIMIT_USD),
      },
      percentage: {
        message: MAX_AMOUNT.MESSAGE_PERCENTAGE,
        rule: (val) => MAX_AMOUNT.MIN_AMOUNT <= Number(val && val.replace(/,/g, '')) && Number(val && val.replace(/,/g, '')) <= MAX_AMOUNT.LIMIT_MAX,
      },
      frequency: {
        message: 'Billing period should not be more than 365 days',
        // eslint-disable-next-line radix
        rule: (val) => parseInt(val) <= 365,
      },
    },
  }));

  const exportData = plans ? plans.map((values) => ({
    name: values.name,
    billingPeriod: `Every ${values.billingPeriod} ${getFrequency(values.billingFrequency)}`,
    createdAt: moment
      .utc(values.createdAt)
      .tz(selectedAccount.timezone)
      .format('MMM DD, YYYY, hh:mm a'),
  })) : '';

  const exportHeaders = [
    { label: 'PLAN NAME', key: 'name' },
    { label: 'BILLING CYCLE', key: 'billingPeriod' },
    { label: 'CREATED ON', key: 'createdAt' },
  ];

  const debouncedFetchPlanV2 = debounce(fetchPlanV2, 2000, { leading: true });
  const debouncedFetchInventoryItems = debounce(fetchInventoryItems, 2000, { leading: true });

  const getData = (query) => {
    const parsed = queryString.parse(query);
    const currentPage = parsed.pageNum || 1;
    const sortBy = parsed.sortBy || 'createdAt';
    const direction = parsed.direction || 'DESC';
    const sortParams = `&sortBy=${sortBy}&direction=${direction}`;
    const filterParam = parsed.filterParams || '';
    const filterParams = (preserveParam ? preserveParam.filterParams : filterParam || '');
    debouncedFetchPlanV2({ currentPage, sortParams, filterParams });
  };

  const getDataItems = (query) => {
    const parsed = queryString.parse(query);
    const currentPage = parsed.pageNum || 1;
    const sortBy = parsed.sortBy || 'name';
    const direction = parsed.direction || 'ASC';
    const sortParams = `&sortBy=${sortBy}&direction=${direction}`;
    debouncedFetchInventoryItems({
      currentPage, sortParams,
    });
  };

  useEffect(() => {
    getDataItems(location.search);
  }, [selectedAccount]);

  useEffect(() => {
    getData(location.search);
  }, [location, test, selectedAccount]);

  useEffect(() => {
    setAllTaxes(taxList);
  }, [taxList]);

  useEffect(() => {
    if (!validator) {
      setAddProductModal(false);
      setAddCouponModal(false);
      setAddTaxModal(false);
      setAddItemModal(false);
    }
    if (redirect && !validator) {
      setAddPlansModal(false);
    }
  }, [validator]);

  useEffect(() => {
    if (addedProduct && addedNewProduct && addedNewProduct.gid && lineItemDtoList) {
      const list = [...lineItemDtoList];
      const { amount } = addedNewProduct;
      list[lineItemIndex].name = addedNewProduct.name;
      list[lineItemIndex].description = addedNewProduct.name;
      list[lineItemIndex].note = addedNewProduct.note;
      list[lineItemIndex].rate = (amount / 100).toFixed(2);
      list[lineItemIndex].productGid = addedNewProduct.gid;
      // only upfront key is set while adding products
      list[lineItemIndex].recurring = !addedNewProduct.upfront;
      list[lineItemIndex].upfront = addedNewProduct.upfront;
      list[lineItemIndex].priceType = addedNewItem.priceType;
      list[lineItemIndex].currencyCode = addedNewProduct.currency && addedNewProduct.currency.name;
      list[lineItemIndex].amount = amount;
      const amountTotal = list.reduce((total, item) => total + ((item.rate * item.quantity)), 0);
      setTotalAmount(amountTotal);
      setLineItemDtosList(list);
    }
  }, [addedNewProduct]);

  useEffect(() => {
    if (addedItem && addedNewItem && addedNewItem.gid && lineItemDtoList) {
      const list = [...lineItemDtoList];
      const { price } = addedNewItem;
      list[lineItemIndex].name = addedNewItem.name;
      list[lineItemIndex].description = addedNewItem.name;
      list[lineItemIndex].note = addedNewItem.note;
      list[lineItemIndex].rate = (price / 100).toFixed(2);
      list[lineItemIndex].itemGid = addedNewItem.gid;
      list[lineItemIndex].upfront = !addedNewItem.recurring;
      list[lineItemIndex].recurring = addedNewItem.recurring;
      list[lineItemIndex].currencyCode = currencyCode;
      list[lineItemIndex].priceType = addedNewItem.priceType;
      list[lineItemIndex].amount = price;
      const amountTotal = list.reduce((total, item) => total + ((item.rate * item.quantity)), 0);
      setTotalAmount(amountTotal);
      setLineItemDtosList(list);
    }
  }, [addedNewItem]);

  const handleClick = e => {
    if (myRef.current && myRef.current.contains(e.target)) {
      return;
    }
    if (e.target.value === undefined
      && e.toElement.className !== 'ant-calendar-date'
      && e.toElement.className !== 'ant-calendar-prev-month-btn'
      && e.toElement.className !== 'ant-calendar-next-month-btn') {
      setOpen(false);
    }
  };

  useEffect(() => {
    const parsed = queryString.parse(location.search);
    const currentPage = parsed.pageNum || 1;
    setPagination(existingElements => ({
      ...existingElements,
      total: totalElements,
      current: parseInt(currentPage, 10),
      showTotal: total => `Total ${total} items`,
    }));
  }, [plans]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);

  useEffect(() => {
    getProductsList();
  }, [selectedAccount]);

  useEffect(() => {
    setCustomerList(customerResult);
  }, [customerResult]);

  useEffect(() => {
    if (newTaxrate.gid && taxRedirect) {
      const listOfTaxes = [...allSelectedTaxrates];
      const taxRates = {};
      Object.assign(taxRates, newTaxrate);
      const taxRate = {
        taxRates,
      };
      listOfTaxes.push(taxRate);
      setAllSelectedTaxrates(listOfTaxes);
    }
  }, [newTaxrate]);

  const addNewPlans = (event) => {
    event.preventDefault();
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }
    const taxlist = [];
    for (let i = 0; i < allSelectedTaxrates.length; i += 1) {
      taxlist.push(allSelectedTaxrates[i]?.taxRates?.gid);
    }
    const payload = {
      currencyCode,
      name: planName,
      description,
      note: description,
      billingFrequency: frequency,
      billingPeriod: Number(period),
      delayStartDays: Number(delayStartDate),
      freeTrialDays: Number(freeTrialDays),
      overDueFees: Number(overdueFee) * 100,
      overDueFeeType: feesType,
      savedPaymentsLimit: Number(limitPaymentMethods),
      nextChargeAttemptDelayDays: Number(nextAttempt),
      notificationType: notify,
      plan2TotalPayments: Number(count1),
      allowCustomerPauseOrCancel: pauseType === 'YES',
      canCustomerCancelOrPause: pauseType === 'YES',
      subscriptionChargeType: surCharge,
      allowManualPayments: allowManualPayment,
      addToPlanManager,
      plan2LineItems: lineItemDtoList,
      taxRates: taxlist,
      couponGid: updatedCoupon?.gid || null,
      shippingFee: shippingAmount ? Number(((shippingAmount).replace('.', '').replace(',', ''))) : null,
    };
    addPlanV2(payload);
    setRedirect(true);
  };

  const handleTableChange = (page, sorter, filters) => {
    const parsed = queryString.parse(location.search);
    const filterParams = parsed.filterParams || '';
    const tempPage = page.current;
    let tempParams = '';
    if (filters.order === 'ascend') {
      tempParams = `&sortBy=${filters.field}&direction=ASC`;
    } else if (filters.order === 'descend') {
      tempParams = `&sortBy=${filters.field}&direction=DESC`;
    } else {
      tempParams = '';
    }
    if (location.search && filterParams) {
      const filterParam = encodeURIComponent(filterParams);
      history.push({
        pathname: '/subscriptions/plans',
        search: `?filterParams=${filterParam}&pageNum=${tempPage}${tempParams}`,
      });
    } else {
      history.push({
        pathname: '/subscriptions/plans',
        search: `?pageNum=${tempPage}${tempParams}`,
      });
    }
  };

  const selectedRecord = (record) => {
    const planGid = record.gid;
    history.push({
      pathname: `/subscriptions/plans/${planGid}`,
      state: location.search,
    });
  };

  const onCheck = (e, index) => {
    const list = [...filterPlans];
    if (filterPlans.length !== 1) {
      if (!e) {
        list.splice(index, 1);
        const filterTypeOptions = PLAN_FILTERS_TYPES.filter(({ value: id1 }) => !list.some(({ filterName: id2 }) => id2 === id1));
        setFilterTypes(filterTypeOptions);
      } else {
        list[index].checked = e;
      }
    }
    setFilterPlan(list);
  };

  const handleChange = (e, index) => {
    const list = [...filterPlans];
    if (e[1] === 'createdAt') {
      list[index].filterType = 'Date';
    } else if (e[1] === 'amount') {
      list[index].filterType = 'Number';
    } else {
      list[index].filterType = 'String';
    }
    list[index].filterName = e[1];
    list[index].filterNameDisplay = e[0];
    list[index].filterOperator = '';
    list[index].filterValue = '';
    const filterTypeOptions = PLAN_FILTERS_TYPES.filter(({ value: id1 }) => !list.some(({ filterName: id2 }) => id2 === id1));
    setFilterPlan(list);
    setFilterTypes(filterTypeOptions);
    setFilterOperators(getFilterOperators(e[1]));
  };

  const handleFromValue = (e, index) => {
    const list = [...filterPlans];
    const regex = /^\d*\.?\d*$/;
    if (e.currentTarget && regex.test(e.currentTarget.value.replace(/,/g, ''))) {
      list[index].filterValueFrom = e.currentTarget.value;
      setFilterPlan(list);
    } else if (regex.test(e.replace(/,/g, ''))) {
      list[index].filterValueFrom = e;
      setFilterPlan(list);
    }
  };

  const handleToValue = (e, index) => {
    const list = [...filterPlans];
    const regex = /^\d*\.?\d*$/;
    if (e.currentTarget && regex.test(e.currentTarget.value.replace(/,/g, ''))) {
      list[index].filterValueTo = e.currentTarget.value;
      setFilterPlan(list);
    } else if (regex.test(e.replace(/,/g, ''))) {
      list[index].filterValueTo = e;
      setFilterPlan(list);
    }
  };

  const handleValue = (e, index) => {
    let selectedValue = '';
    if (filterPlans[index].filterName === 'createdAt') {
      if (filterPlans[index].filterOperator === 'BT') {
        const date1 = e[0];
        const date2 = e[1];
        const utcDate1 = moment(date1).endOf('day');
        setStartDate(utcDate1);
        const utcDate2 = moment(date2).startOf('day');
        setEndDate(utcDate2);
        const utcString1 = utcDate1.format(MOMENT_FORMAT);
        const utcString2 = utcDate2.format(MOMENT_FORMAT);
        const selectedDate1 = moment.tz(utcString1, selectedAccount.timezone);
        const selectedDate2 = moment.tz(utcString2, selectedAccount.timezone);
        const dateStart = selectedDate1.utc().format(MOMENT_FORMAT);
        const dateEnd = selectedDate2.utc().format(MOMENT_FORMAT);
        selectedValue = `createdAt.GT=${dateStart}&createdAt.LT=${dateEnd}`;
      } else if (filterPlans[index].filterOperator === 'LT') {
        const utcDate = moment(e).startOf('day');
        setCurrentDate(utcDate);
        const utcString = utcDate.format(MOMENT_FORMAT);
        const dateSelected = moment.tz(utcString, selectedAccount.timezone);
        const dateStart = dateSelected.utc().format(MOMENT_FORMAT);
        selectedValue = `createdAt.LT=${dateStart}`;
      } else if (filterPlans[index].filterOperator === 'GT') {
        const utcDate = moment(e).endOf('day');
        setCurrentDate(utcDate);
        const utcString = utcDate.format(MOMENT_FORMAT);
        const dateSelected = moment.tz(utcString, selectedAccount.timezone);
        const dateStart = dateSelected.utc().format(MOMENT_FORMAT);
        selectedValue = `createdAt.GT=${dateStart}`;
      }
    } else if (filterPlans[index].filterName === 'status') {
      selectedValue = e;
    } else {
      if (!e.currentTarget) {
        selectedValue = e;
      }
      if (e.currentTarget && e.currentTarget.value) {
        selectedValue = e.currentTarget.value;
      }
    }
    const list = [...filterPlans];
    list[index].filterValue = selectedValue;
    setFilterPlan(list);
  };

  const handleOperator = (e, index) => {
    const list = [...filterPlans];
    list[index].filterOperator = e;
    if (list[index].filterValue) {
      if (list[index].filterOperator !== 'BT'
        && list[index].filterName === 'createdAt') {
        handleValue(currentDate, index);
      } else if (list[index].filterOperator === 'BT'
        && list[index].filterName === 'createdAt') {
        const dateList = [startDate, endDate];
        handleValue(dateList, index);
      } else if (list[index].filterOperator !== 'BT'
        && list[index].filterOperator !== 'LT'
        && list[index].filterOperator !== 'GT') {
        const value = filterPlans[index].filterValue;
        handleValue(value, index);
      }
    }
    setFilterPlan(list);
  };


  const handleAddClick = () => {
    const list = [...filterPlans];
    setFilterPlan([...list, {
      filterType: '',
      filterName: '',
      filterOperator: '',
      filterValue: '',
      filterNameDisplay: '',
      filterValueFrom: '',
      filterValueTo: '',
      checked: true,
    }]);
  };

  const resetFilters = () => {
    setFilterData({
      pathname,
      search: '',
    });
    setFilterPlan([{
      filterType: '',
      filterName: '',
      filterOperator: '',
      filterValue: '',
      filterNameDisplay: '',
      filterValueFrom: '',
      filterValueTo: '',
      checked: true,
    }]);
    setFilterTypes(PLAN_FILTERS_TYPES);
    setStartDate('');
    setEndDate('');
    setCurrentDate('');
    setCount(null);
    history.push(PAGES.SUBSCRIPTION_PLAN);
  };

  const applyFilters = () => {
    const disputesFilters = filterPlans.filter((item) => item.checked);
    for (let i = 0; i < disputesFilters.length; i += 1) {
      if (!disputesFilters[i].filterName || !disputesFilters[i].filterOperator || !disputesFilters[i].filterValue) {
        return;
      }
    }
    if (disputesFilters[0].filterValue || (disputesFilters[0].filterValueFrom && disputesFilters[0].filterValueTo)) {
      setCount(disputesFilters && disputesFilters.length);
      for (let i = 0; i < disputesFilters.length; i += 1) {
        if (disputesFilters[i].checked) {
          if (disputesFilters[i].filterName === 'createdAt') {
            disputesFilters[i] = disputesFilters[i].filterValue;
          } else if (disputesFilters[i].filterName === 'amount' && disputesFilters[i].filterOperator === 'BT') {
            const name = disputesFilters[i].filterName;
            const from = disputesFilters[i].filterValueFrom.replace(/[. ,:-]+/g, '');
            const to = disputesFilters[i].filterValueTo.replace(/[. ,:-]+/g, '');
            disputesFilters[i] = `${name}.GT=${from}&${name}.LT=${to}`;
          } else if (disputesFilters[i].filterName === 'amount' && disputesFilters[i].filterOperator !== 'BT') {
            const value = disputesFilters[i].filterValue.replace(/[. ,:-]+/g, '');
            disputesFilters[i] = `${disputesFilters[i].filterName}.${disputesFilters[i].filterOperator}=${value}`;
          } else {
            disputesFilters[i] = `${disputesFilters[i].filterName}.${disputesFilters[i].filterOperator}=${disputesFilters[i].filterValue}`;
          }
        }
      }

      const filterParams = encodeURIComponent(disputesFilters.join('&'));
      const parsed = queryString.parse(location.search);
      const currentPage = 1;
      const sortBy = parsed.sortBy || 'createdAt';
      const direction = parsed.direction || 'DESC';
      const sortParams = `&sortBy=${sortBy}&direction=${direction}`;
      if (location.search && parsed.sortBy && parsed.pageNum && parsed.direction) {
        setFilterData({
          pathname,
          search: `?filterParams=${filterParams}&pageNum=${currentPage}${sortParams}`,
          filterPlans,
        });
        history.push({
          pathname: PAGES.SUBSCRIPTION_PLAN,
          search: `?filterParams=${filterParams}&pageNum=${currentPage}${sortParams}`,
        });
      } else {
        setFilterData({
          pathname,
          search: `?filterParams=${filterParams}`,
          filterPlans,
        });
        history.push({
          pathname: PAGES.SUBSCRIPTION_PLAN,
          search: `?filterParams=${filterParams}`,
        });
      }
    }
  };

  const getFinalAmount = (amount) => {
    let finalAmount;
    const listOfTaxes = [...allSelectedTaxrates];
    const taxLists = listOfTaxes.filter((item) => item.taxRates.inclusive === false);
    if (taxLists.length > 0) {
      const percentageAmount = taxLists.reduce(
        (total, item) => total + ((parseFloat(amount.replace(/,/g, '')) * item.taxRates.percentage) / 100), 0,
      );
      finalAmount = formatNumber((parseFloat(amount.replace(/,/g, '')) + percentageAmount).toFixed(2), currencyObj);
    } else {
      finalAmount = amount;
    }
    return finalAmount;
  };

  const getTotalAmount = (value) => {
    let finalAmount;
    if (value) {
      const finalValue = parseFloat(value.replace(/,/g, ''));
      finalAmount = formatNumber((totalAmount - finalValue)?.toFixed(2), currencyObj);
    } else {
      finalAmount = formatNumber((totalAmount)?.toFixed(2), currencyObj);
    }
    return finalAmount;
  };

  const getAmountOff = (value) => {
    let amountOff;
    if (value.percentageOff) {
      const amount = (totalAmount * value.percentageOff) / 100;
      amountOff = formatNumber((amount)?.toFixed(2), currencyObj);
    } else if (value.amountOff) {
      amountOff = formatNumber((value.amountOff / 100)?.toFixed(2), currencyObj);
    }
    return amountOff;
  };

  const onProductListSearch = (productSearch) => {
    getProductsList(productSearch);
  };

  const handleChangeItems = (e, index) => {
    const gid = e[1];
    const productInfo = inventoryItems.filter((item) => (item.gid === gid));
    const list = [...lineItemDtoList];
    const { price, priceType } = productInfo[0];
    // list[index].productGid = productInfo[0].gid;
    list[index].upfront = !productInfo[0].recurring;
    list[index].recurring = productInfo[0].recurring;
    list[index].currencyCode = currencyCode;
    list[index].name = productInfo[0].name;
    list[index].itemGid = gid;
    list[index].description = productInfo[0].description;
    list[index].note = productInfo[0].note;
    list[index].rate = (price / 100).toFixed(2);
    list[index].priceType = priceType;
    list[index].amount = price;
    const amountTotal = list.reduce((total, item) => total + ((item.rate * item.quantity)), 0);
    setTotalAmount(amountTotal);
    setLineItemDtosList(list);
  };

  const handleChangeProduct = (e, index) => {
    const gid = e[1];
    const productInfo = productsList.filter((item) => (item.gid === gid));
    const list = [...lineItemDtoList];
    const { amount } = productInfo[0];
    list[index].productGid = productInfo[0].gid;
    list[index].upfront = productInfo[0].upfront;
    list[index].currencyCode = productInfo[0].currency && productInfo[0].currency.name;
    // list[index].productGid = productInfo[0].gid;
    list[index].name = productInfo[0].name;
    list[index].description = productInfo[0].description;
    list[index].note = productInfo[0].note;
    list[index].rate = (amount / 100).toFixed(2);
    list[index].itemGid = productInfo[0].gid;
    list[index].amount = amount;
    const amountTotal = list.reduce((total, item) => total + ((item.rate * item.quantity)), 0);
    setTotalAmount(amountTotal);
    setLineItemDtosList(list);
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.currentTarget;
    let regex;
    if (name === 'quantity') {
      regex = /^[0-9\b]+$/;
    } else if (name === 'rate') {
      regex = /^\d*\.?\d*$/;
    }
    const list = [...lineItemDtoList];
    if (regex.test(value) || value === '') {
      list[index][name] = value;
      if (name === 'rate' && value) {
        const sum = list[index].rate * 100;
        list[index].amount = sum;
      }
    } else if (!regex.test(value) && name === 'quantity') {
      list[index][name] = '1';
    } else if (!regex.test(value) && name === 'rate') {
      list[index][name] = 0;
    }
    const amountTotal = list.reduce((total, item) => total + ((item.rate * item.quantity)), 0);
    setTotalAmount(amountTotal);
    setLineItemDtosList(list);
  };

  const handleRemoveClick = index => {
    const list = [...lineItemDtoList];
    list.splice(index, 1);
    const amountTotal = list.reduce((total, item) => total + ((item.rate * item.quantity)), 0);
    setTotalAmount(amountTotal);
    setLineItemDtosList(list);
  };

  const getAmountWithShippingFee = (amount) => {
    if (shippingAmount) {
      const numericAmount = parseFloat(amount.replace(/,/g, '')) || 0;
      const numericShippingAmount = parseFloat(shippingAmount) || 0;
      const addedShippingAmount = numericAmount + numericShippingAmount;
      return addedShippingAmount.toFixed(2);
    }
    return amount;
  };

  const onItemSearch = (itemSearch) => {
    const sortParams = '&sortBy=name&direction=ASC';
    const currentPage = 1;
    const filterParams = '';
    debouncedFetchInventoryItems({
      currentPage, sortParams, filterParams, nameSearch: itemSearch ? (itemSearch === '' ? null : `&name.LIKE=${itemSearch}`) : null,
    });
  };

  const onItemListSearch = (productSearch) => {
    onItemSearch(productSearch);
  };

  const formatInputChange = (e, index) => {
    const { name, value } = e.currentTarget;
    const list = [...lineItemDtoList];
    const rateValue = parseFloat(value);
    if (Number.isInteger(rateValue)) {
      list[index][name] = parseInt(value, 10).toFixed(2);
    }
    setLineItemDtosList(list);
  };

  const getListItems = () => {
    const sortParams = '&sortBy=name&direction=ASC';
    const currentPage = 1;
    const filterParams = '';
    debouncedFetchInventoryItems({
      currentPage, sortParams, filterParams,
    });
  };

  const handleAddClickProduct = (Type) => {
    if (Type === 'product') {
      getListItems();
      getProductsList();
    } else {
      getDataItems();
    }

    setLineItemDtosList([...lineItemDtoList, {
      amount: 0,
      rate: 0,
      productGid: '',
      currencyCode: '',
      description: '',
      name: '',
      note: '',
      quantity: '1',
      recurring: '',
      itemGid: '',
    }]);
  };

  const addNewCuponforPlan = (value) => {
    setSelectCouponModal(value);
  };

  const updateCoupon = (Coupon: Object) => {
    setUpdatedCoupon(Coupon);
    setSelectCouponModal(false);
  };

  const newCouponAdd = () => {
    setSelectCouponModal(false);
    setAddCouponModal(true);
  };

  const addCoupon = (coupon: Object) => {
    const {
      name,
      percentageOff,
      amountOff,
      validity,
      expiresAt,
      maximumRedemption,
      code,
      minimumAmount,
      promotionalRedeemed,
      promoExpiresAt,
      promotional,
      customerGid,
      validiyInMonths,
    } = coupon;
    const params = {
      active: true,
      name,
      percentageOff: (percentageOff ? parseFloat(percentageOff) : null),
      amountOff: (amountOff ? parseInt((amountOff).replace(/[_\W]+/g, ''), 10) : null),
      validity,
      expiresAt,
      maximumRedemption: (maximumRedemption ? parseInt(maximumRedemption, 10) : null),
      validiyInMonths: (validiyInMonths ? parseInt(validiyInMonths, 10) : null),
      currencyCode,
    };
    const payload = {
      active: true,
      code,
      enabledForCheckout: true,
      expiresAt: promoExpiresAt,
      maximumRedemption: promotionalRedeemed ? parseInt(promotionalRedeemed, 10) : null,
      minimumAmount: minimumAmount ? parseInt((minimumAmount).replace(/[_\W]+/g, ''), 10) : null,
      minimumAmountCurrency: currencyCode,
      restrictedToCustomers: [
        customerGid,
      ],
    };
    if (promotional) {
      addNewCoupon({
        params,
        payload,
      });
    } else if (!promotional) {
      addNewCoupon({
        params,
      });
    }
  };

  const fetchCustomer = (searchText) => {
    getCustomersList(searchText);
  };

  const addNewTaxforPlan = (value) => {
    setSelectTaxrateModal(value);
  };

  const updateTaxrate = (Taxrate: Object) => {
    const listOfTaxes = [...allSelectedTaxrates];
    listOfTaxes.push(Taxrate);
    setAllSelectedTaxrates(listOfTaxes);
    setSelectTaxrateModal(false);
  };

  const newTaxAdd = () => {
    setSelectTaxrateModal(false);
    setAddTaxModal(true);
  };

  const fetchTaxDetails = (searchParams) => {
    getTaxes(searchParams);
  };

  const addTaxrate = (taxRate: Object) => {
    const {
      displayName,
      jurisdiction,
      percentage,
      inclusive,
      taxDescription,
    } = taxRate;
    const params = {
      displayName,
      jurisdiction,
      percentage,
      inclusive,
      description: taxDescription,
    };
    addNewTaxRate({
      params,
    });
    setTaxRedirect(true);
  };

  const removeTax = (i) => {
    const listOfTaxes = [...allSelectedTaxrates];
    listOfTaxes.splice(i, 1);
    setAllSelectedTaxrates(listOfTaxes);
  };

  const updateShippingFee = (amount: Number) => {
    setShippingAmount(amount);
    setSelectedShippingFeeModal(false);
  };

  const removeShippingFee = () => {
    setShippingAmount(null);
    simpleValidator.current.purgeFields();
  };

  const addNewProductforPlan = () => {
    setAddProductModal(true);
  };

  const addNewProduct = (newProduct: Object) => {
    const {
      productName,
      currency,
      productDescription,
      amount,
      productNotes,
      upfront,
    } = newProduct;

    const productAmount = amount.replace(/[. ,:-]+/g, '');

    const params = {
      name: productName,
      currencyCode: currency,
      description: productDescription,
      amount: Number(productAmount),
      note: productNotes,
      paymentMethodType: [
        'CARD',
      ],
      statementDescription: '',
      upfront,
    };

    addNewProcut({
      params,
    });
    setAddedProduct(true);
  };

  const onFeesChange = (e) => {
    setFeesType(e.target.value);
  };

  const addNewItemforPlan = () => {
    setAddItemModal(true);
    fetchItemsList('&sortBy=name&direction=DESC');
    fetchModifierItemsList('&sortBy=name&direction=DESC');
    fetchPrinterLabelList('&sortBy=createdAt&direction=DESC');
  };

  const addSelectedItem = (customer: Object) => {
    const {
      name,
      price,
      alternateName,
      onlineName,
      onlineEnabled,
      sku,
      isPos,
      priceType,
      primaryColor,
      categories,
      order,
      modifierGroups,
      isItemAvailable,
      cost,
      logoUrl,
      // eslint-disable-next-line no-shadow
      description,
      tagDetails,
      enableStock,
      enableDynamicAvailability,
      stockQuantity,
      onlineAvailability,
      posAvailability,
      shopDetails,
      isRecurring,

    } = customer;
    const totalPrice = price ? price.replace(/[^\d]/g, '') : 0;
    const totalCost = cost ? cost.replace(/[^\d]/g, '') : 0;

    const params = {
      name,
      alternateName,
      onlineName,
      onlineEnabled,
      sku,
      price: Number(totalPrice),
      hidden: !isPos,
      priceType,
      sortOrder: Number(order),
      colorCode: primaryColor,
      categoryGids: categories || null,
      shopGids: shopDetails || [],
      modifierGroupGids: modifierGroups || null,
      available: isItemAvailable,
      cost: Number(totalCost),
      imageUrl: logoUrl,
      description,
      tagGids: tagDetails || [],
      enableStock,
      enableDynamicAvailability,
      stockQuantity: Number(stockQuantity),
      onlineAvailability: Number(onlineAvailability * 100),
      posAvailability: Number(posAvailability * 100),
      recurring: isRecurring,
    };
    addInventoryItems({
      params,
    });
    setAddedItem(true);
  };

  const columns = [
    {
      title: 'PLAN NAME',
      dataIndex: 'name',
      width: '20%',
      align: 'left',
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (name) => (
        <Tooltip placement="top" title="Click here to view details">
          <span style={{ cursor: 'pointer' }}>
            {name || <>&#8211;</>}
          </span>
        </Tooltip>
      ),
    },
    {
      title: 'BILLING CYCLE',
      dataIndex: 'billingPeriod',
      width: '20%',
      align: 'left',
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        <Tooltip placement="top" title="Click here to view details">
          <span style={{ cursor: 'pointer' }}>
            {text ? `Every ${text} ${getFrequency(record.billingFrequency)}` : (
              <>
                {
                  record.billingFrequency && !text ? (
                    <>{getBillingFrequency(record.billingFrequency)}</>
                  ) : (
                    <>&#8211;</>
                  )
                }
              </>
            )}
          </span>
        </Tooltip>
      ),
    },
    {
      title: 'CREATED ON',
      dataIndex: 'createdAt',
      width: '20%',
      align: 'left',
      sorter: true,
      defaultSortOrder: 'descend',
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (createdAt) => {
        if (createdAt && selectedAccount && selectedAccount.timezone) {
          const tzDate = moment
            .utc(createdAt)
            .tz(selectedAccount.timezone)
            .format('MMM DD, YYYY, hh:mm a');
          return (<span>{tzDate}</span>);
        }
        return (
          <>&#8211;</>
        );
      },
    },
    {
      title: 'IN PLAN MANAGER',
      dataIndex: 'addToPlanManager',
      width: '20%',
      align: 'center',
      sorter: false,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        <Tooltip placement="top" title="Click here to view details">
          <span style={{ cursor: 'pointer' }}>
            {(record?.addToPlanManager ? 'YES' : 'NO') || <>&#8211;</>}
          </span>
        </Tooltip>
      ),
    },
  ];

  if (loading || !selectedAccount) {
    return <Loading />;
  }

  return (
    <>
      {
      addPlansModal ? (
        <Card>
          <Row>
            <Col span={11} className="mr-3">
              <div className="mt-2 mb-3">
                <label htmlFor=""><SpH5>Plan Name</SpH5></label>
                <Input
                  placeholder="Enter a plan name"
                  type="text"
                  value={planName}
                  onChange={(e) => setPlanName(e.currentTarget.value)}
                />
                <SpError>
                  {simpleValidator.current.message('plan name', planName, 'required|stringLength')}
                </SpError>
              </div>
              <div className="mb-3">
                <label htmlFor=""><SpH5>Plan Description</SpH5></label>
                <Input
                  placeholder="Optional"
                  value={description}
                  onChange={(e) => setDescription(e.currentTarget.value)}
                />
              </div>
              <div className="mb-3">
                <label htmlFor=""><SpH5>Billing Frequency</SpH5></label>
                <div className="d-flex align-items-center" style={{ width: '50%' }}>
                  <span>Every</span>
                  <div style={{ width: '18%', minWidth: '35px' }}>
                    <Input
                      className="ml-1"
                      maxlength="3"
                      value={period}
                      onChange={(e) => {
                        const regex = /^[0-9\b]+$/;
                        const { value } = e.currentTarget;
                        if (regex.test(value) || value === '') {
                          setPeriod(e.currentTarget.value);
                        } else if (!regex.test(value)) {
                          setPeriod();
                        }
                      }}
                      onKeyPress={e => {
                        const keyCode = e.charCode || e.which;
                        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                  <div>
                    <Select
                      className="ml-3"
                      style={{ width: '155%' }}
                      value={frequency}
                      onChange={(e) => setFrequency(e)}
                    >
                      <Option key={1} value="DAY">Day(s)</Option>
                      <Option key={2} value="WEEK">Week(s)</Option>
                      <Option key={3} value="MONTH">Month(s)</Option>
                      <Option key={4} value="YEAR">Year(s)</Option>
                    </Select>
                  </div>
                </div>
                {
                    frequency === 'DAY' ? (
                      <SpError>
                        {simpleValidator.current.message('period', period, 'required|frequency')}
                      </SpError>
                    ) : (
                      <SpError>
                        {simpleValidator.current.message('period', period, 'required')}
                      </SpError>
                    )
                  }
              </div>
              <div className="mb-3">
                <label htmlFor=""><SpH5>Billing Amount</SpH5></label>
                <div>
                  Customer will be charged&nbsp;
                  <SpH5>
                    {
                        (getFinalAmount(getTotalAmount(getAmountOff(updatedCoupon)))) < 0 ? (
                          `${prefix} 0.00`
                        ) : (
                          `${prefix} ${getAmountWithShippingFee(getFinalAmount(getTotalAmount(getAmountOff(updatedCoupon)))) || '0.00'}`
                        )
                      }
                  </SpH5> every
                  <SpH5> {`${period} ${getFrequency(frequency)}`}</SpH5>
                </div>
              </div>
              <div className="mb-3 d-flex align-items-center">
                <div style={{ width: '30%' }} className="mr-3">
                  <label htmlFor=""><SpH5>Delay Start Date (Optional)</SpH5></label>
                  <div>
                    <Input
                      placeholder="Enter Number (Days)"
                      maxlength="3"
                      disabled={disableDelay}
                      value={delayStartDate}
                      onChange={(e) => {
                        const regex = /^[0-9\b]+$/;
                        const { value } = e.currentTarget;
                        if (regex.test(value) || value === '') {
                          setDelayStartDate(e.currentTarget.value);
                          setDisableFree(true);
                          if (value === '') {
                            setDisableFree(false);
                          }
                        } else if (!regex.test(value)) {
                          setDelayStartDate();
                          setDisableFree(false);
                        }
                      }}
                      onKeyPress={e => {
                        const keyCode = e.charCode || e.which;
                        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
                <div style={{ width: '30%' }} className="ml-3">
                  <label htmlFor=""><SpH5>Free Trial Days (Optional)</SpH5></label>
                  <div>
                    <Input
                      placeholder="Enter Number (Days)"
                      maxlength="3"
                      disabled={disableFree}
                      value={freeTrialDays}
                      onChange={(e) => {
                        const regex = /^[0-9\b]+$/;
                        const { value } = e.currentTarget;
                        if (regex.test(value) || value === '') {
                          setFreeTrialDays(e.currentTarget.value);
                          setDisableDelay(true);
                          if (value === '') {
                            setDisableDelay(false);
                          }
                        } else if (!regex.test(value)) {
                          setFreeTrialDays();
                          setDisableDelay(false);
                        }
                      }}
                      onKeyPress={e => {
                        const keyCode = e.charCode || e.which;
                        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="mb-3 d-flex align-items-center">
                <div style={{ width: '30%' }} className="mr-3">
                  <label htmlFor=""><SpH5>Add Overdue Fees (Optional)</SpH5></label>
                  <div>
                    <Input
                      maxlength="3"
                      suffix={feesType === 'PERCENT' ? '%' : prefix}
                      value={overdueFee}
                      onChange={(e) => {
                        const regex = /^[0-9\b]+$/;
                        const { value } = e.currentTarget;
                        if (regex.test(value) || value === '') {
                          setOverdueFee(e.currentTarget.value);
                        } else if (!regex.test(value)) {
                          setOverdueFee();
                        }
                      }}
                      onKeyPress={e => {
                        const keyCode = e.charCode || e.which;
                        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
                <div style={{ width: '30%' }} className="ml-3">
                  <label htmlFor=""><SpH5>&nbsp;</SpH5></label>
                  <div>
                    <Radio.Group onChange={onFeesChange} value={feesType}>
                      <Radio value="PERCENT">Percentage</Radio>
                      <Radio value="AMOUNT">Flat Amount</Radio>
                    </Radio.Group>
                  </div>
                </div>
              </div>
              <div className="mb-3 d-flex align-items-center">
                <div style={{ width: '60%' }} className="mr-3">
                  <label htmlFor=""><SpH5>Limit Saved Payment Methods (Optional)</SpH5></label>
                  <div>
                    <Input
                      placeholder="Enter Number"
                      maxlength="3"
                      value={limitPaymentMethods}
                      onChange={(e) => {
                        const regex = /^[0-9\b]+$/;
                        const { value } = e.currentTarget;
                        if (regex.test(value) || value === '') {
                          setLimitPaymentMethods(e.currentTarget.value);
                        } else if (!regex.test(value)) {
                          setLimitPaymentMethods();
                        }
                      }}
                      onKeyPress={e => {
                        const keyCode = e.charCode || e.which;
                        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
                <div style={{ width: '30%' }} className="ml-3">
                  <label htmlFor=""><SpH5>Allow Manual Payments</SpH5></label>
                  <div>
                    <Checkbox
                      checked={allowManualPayment}
                      onChange={({ target: { checked } }) => {
                        setAllowManualPayment(checked);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="mb-3 d-flex align-items-center">
                <div style={{ width: '60%' }} className="mr-3">
                  <label htmlFor=""><SpH5>Next Charge Attempt after Fail (Optional)</SpH5></label>
                  <div>
                    <Input
                      placeholder="Enter Number (days)"
                      maxlength="3"
                      value={nextAttempt}
                      onChange={(e) => {
                        const regex = /^[0-9\b]+$/;
                        const { value } = e.currentTarget;
                        if (regex.test(value) || value === '') {
                          setNextAttempt(e.currentTarget.value);
                        } else if (!regex.test(value)) {
                          setNextAttempt();
                        }
                      }}
                      onKeyPress={e => {
                        const keyCode = e.charCode || e.which;
                        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="mt-3" style={{ width: '50%' }}>
                <label htmlFor=""><SpH5>Notify</SpH5></label>
                <Select
                  className="w-100"
                  value={notify}
                  onChange={(e) => setNotify(e)}
                >
                  <Option key={1} value="EMAIL">Email</Option>
                  <Option key={2} value="SMS">SMS</Option>
                  <Option key={4} value="ALL">Email and SMS</Option>
                </Select>
                <SpError>
                  {simpleValidator.current.message('notify', notify, 'required')}
                </SpError>
              </div>
              <div className="mb-3" style={{ width: '50%' }}>
                <label htmlFor=""><SpH5>Total Count (Optional)</SpH5></label>
                <Input
                  placeholder="No. of billing cycles to be charged"
                  value={count1}
                  onChange={(e) => {
                    const regex = /^[0-9\b]+$/;
                    const { value } = e.currentTarget;
                    if (regex.test(value) || value === '') {
                      setCount1(e.currentTarget.value);
                    } else if (!regex.test(value)) {
                      setCount1(null);
                    }
                  }}
                  onKeyPress={e => {
                    const keyCode = e.charCode || e.which;
                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                      e.preventDefault();
                    }
                  }}
                />
                <SpError>
                  {simpleValidator.current.message('count', count1, 'numeric')}
                </SpError>
              </div>
              <div className="mt-3 d-flex align-items-center">
                <div style={{ width: '60%' }} className="mr-3">
                  <label htmlFor=""><SpH5>Manage Subscription</SpH5></label>
                  <div>
                    <span className="mb-2">Enable Customer to Pause Or Cancel Subscription</span>
                    <Select
                      style={{ width: '100%' }}
                      value={pauseType}
                      onChange={(e) => setPauseType(e)}
                    >
                      <Option key="1" value="YES">YES</Option>
                      <Option key="2" value="No">NO</Option>
                    </Select>
                    <SpError>
                      {simpleValidator.current.message('manage subscription', pauseType, 'required')}
                    </SpError>
                  </div>
                </div>
                <div style={{ width: '30%' }} className="ml-3">
                  <label htmlFor=""><SpH5>Add to Plan Manager</SpH5></label>
                  <div>
                    <Checkbox
                      checked={addToPlanManager}
                      onChange={({ target: { checked } }) => {
                        setAddToPlanManager(checked);
                      }}
                    />
                  </div>
                </div>
              </div>
              {
                pauseType === 'YES' ? (
                  <div className="mt-3 d-flex align-items-center">
                    <div style={{ width: '60%' }} className="mr-3">
                      <label htmlFor=""><SpH5>Subscription Charge Type</SpH5></label>
                      <div>
                        <Select
                          style={{ width: '100%' }}
                          value={surCharge}
                          onChange={(e) => setSurCharge(e)}
                        >
                          <Option key="1" value="SKIP">SKIP</Option>
                          <Option key="2" value="PRORATE">PRORATE</Option>
                          <Option key="3" value="CHARGE">CHARGE</Option>
                        </Select>
                        <SpError>
                          {simpleValidator.current.message('subscription charge type', surCharge, 'required')}
                        </SpError>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )
              }
            </Col>
            <Col span={11} className="ml-3">
              <div className="mt-2 mb-1">
                <label htmlFor="">
                  <SpH5>Select Item</SpH5>

                  <div className="pt-1">
                    {
                        upFrontError && (
                          <SpError>{upFrontError}</SpError>
                        )
                      }
                  </div>
                </label>
              </div>
              <div
                className="mb-4"
                style={{
                  border: '1px solid #C4C4C4',
                  background: '#ffffff',
                  borderRadius: '6px',
                  paddingLeft: '5px',
                }}
              >
                <Row type="flex" className="my-2 mb-3 mt-2">
                  <Col span={8}>
                    <div className="pt-1 pb-1 pl-1"><SpText fontWeight="600">Description</SpText></div>
                  </Col>
                  <Col span={16}>
                    <Row type="flex" justify="end">
                      <Col span={5} className="pt-1 mr-3" align="left">
                        <SpText fontWeight="600" fontSize="14px">Recurring?</SpText>
                      </Col>
                      <Col span={4} className="pt-1 mr-3" align="left">
                        <SpText fontWeight="600" fontSize="14px">Rate</SpText>
                      </Col>
                      <Col span={4} className="pt-1 mr-3" align="center">
                        <SpText fontWeight="600" fontSize="14px">Quantity</SpText>
                      </Col>
                      <Col span={4} className="pt-1 mr-3" align="right">
                        <SpText fontWeight="600" fontSize="14px">Total</SpText>
                      </Col>
                      <Col span={2} className="pt-1" align="right" />
                    </Row>
                  </Col>
                </Row>
                <>
                  <Row type="flex" className="my-2 mb-3 mt-2" style={{ padding: '0 0 0 5px' }}>
                    {lineItemDtoList.map((item, i) => (
                      <>
                        <Col span={8} className="pb-1">
                          <div className="w-100 pr-3">
                            <div onMouseDown={(e) => { e.preventDefault(); return false; }}>
                              <Select
                                value={item.name || 'Select a Item'}
                                style={{ width: '100%' }}
                                showSearch
                                onSearch={onItemListSearch}
                                onSelect={e => handleChangeItems(e, i)}
                                dropdownRender={menu => (
                                  <div>
                                    {menu}
                                    <Divider style={{ margin: '2px 0' }} />
                                    <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 3 }}>
                                      <span
                                        style={{
                                          flex: 'none',
                                          padding: '8px',
                                          display: 'block',
                                          cursor: 'pointer',
                                          color: '#279dfe',
                                        }}
                                        onClick={() => {
                                          addNewItemforPlan(i);
                                          setLineItemIndex(i);
                                        }}
                                      >
                                        <Icon type="plus-circle" />&nbsp;Create New Item
                                      </span>
                                    </div>
                                  </div>
                                )}
                              >
                                {inventoryItems.map((inventoryitem) => (
                                  <Option
                                    key={inventoryitem.gid}
                                    value={[
                                      inventoryitem.name,
                                      inventoryitem.gid,
                                      inventoryitem.price,
                                    ]}
                                  >
                                    {inventoryitem.name}
                                  </Option>
                                ))}
                              </Select>
                            </div>
                            <SpError>
                              {simpleValidator.current.message('product', lineItemDtoList[i].name, 'required')}
                            </SpError>
                          </div>
                        </Col>
                        <Col span={16}>
                          <Row type="flex" justify="end">
                            <Col span={3} className="pt-1 mr-2">
                              {(item.recurring === true) ? 'Yes' : 'No'}
                            </Col>
                            <Col span={5} className="pt-1 mr-4">
                              {/* <SpText fontWeight="600">{prefix} {item.rate || '0.00'}</SpText> */}
                              <Input
                                name="rate"
                                value={item.rate && item.rate}
                                disabled={item.priceType !== 'VARIABLE'}
                                placeholder="0.00"
                                prefix={prefix}
                                onChange={e => handleInputChange(e, i)}
                                onBlur={e => formatInputChange(e, i)}
                                onKeyPress={e => {
                                  const keyCode = e.charCode || e.which;
                                  if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                              {
                                            item.priceType === 'VARIABLE' && (
                                              <SpError>
                                                {simpleValidator.current.message('Rate', lineItemDtoList[i].rate, 'required|amount')}
                                              </SpError>
                                            )
                                          }
                            </Col>
                            <Col span={4} className="mr-3">
                              <Input
                                name="quantity"
                                value={item.quantity}
                                maxlength="3"
                                onChange={e => handleInputChange(e, i)}
                                onKeyPress={e => {
                                  const keyCode = e.charCode || e.which;
                                  if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                              <SpError>
                                {simpleValidator.current.message('Quantity', lineItemDtoList[i].quantity, 'required|numeric')}
                              </SpError>
                            </Col>
                            <Col span={4} className="pt-1 mr-3" align="right">
                              <SpText fontWeight="600">{prefix} {formatNumber((item.rate * item.quantity).toFixed(2), currencyObj)}</SpText>
                            </Col>
                            <Col span={2} className="pt-1" align="right">
                              {i !== 0 ? (
                                <Icon
                                  type="minus-circle"
                                  className="mr-2 mt-1"
                                  style={{ cursor: 'pointer', color: '#ff4d50' }}
                                  onClick={() => handleRemoveClick(i)}
                                />
                              ) : (
                                <span className="mr-2 mt-2">&nbsp;&nbsp;&nbsp;</span>
                              )}
                            </Col>
                          </Row>
                        </Col>
                      </>
                    ))}
                  </Row>
                  <Row type="flex" className="mt-2">
                    <Col span={10}>
                      <div className="pt-1 pb-1 ml-2" style={{ cursor: 'pointer' }}>
                        <SpText
                          fontWeight="600"
                          color="#279dfe"
                          onClick={() => handleAddClickProduct('items')}
                        >
                          {'\u002B'}&nbsp; Add New Item
                        </SpText>
                      </div>
                    </Col>
                    <Col span={14}>
                      <Row type="flex" justify="end" className="ml-1">
                        <Col span={12} className="pt-1 ml-5" align="left">
                          <SpText fontWeight="600" fontSize="14px">Subtotal</SpText>
                        </Col>
                        <Col span={6} className="pt-1 pr-3" align="right">
                          <SpText fontWeight="600">
                            {`${prefix} ${formatNumber((totalAmount)?.toFixed(2), currencyObj)}`}
                          </SpText>
                        </Col>
                        <Col span={2} className="pt-1" align="right" />
                      </Row>
                    </Col>
                  </Row>

                </>
                <hr />
                <Row type="flex" justify="end" className="mr-3 mb-1">
                  <Col className="mt-1 pb-1 mr-3 pr-1">
                    <SpText className="mr-5" fontWeight="500" fontSize="20px">
                      Total Amount
                    </SpText>
                    <SpText fontWeight="600" fontSize="20px">
                      {
                          (getFinalAmount(getTotalAmount(getAmountOff(updatedCoupon)))) < 0 ? (
                            `${prefix} 0.00`
                          ) : (
                            `${prefix} ${getAmountWithShippingFee(getFinalAmount(getTotalAmount(getAmountOff(updatedCoupon))))}`
                          )
                        }
                    </SpText>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

          <Row type="flex" justify="end" gutter={[16, 16]}>
            <Col>
              <SpButton
                type="secondary"
                shape="round"
                onClick={() => setAddPlansModal(false)}
              >
                Cancel
              </SpButton>
            </Col>
            <Col>
              <SpButton
                type="primary"
                shape="round"
                onClick={addNewPlans}
              >
                Save
              </SpButton>
            </Col>
          </Row>

          {/* SELECT COUPON MODAL */}
          {selectCouponModal && (
          <SelectCoupon
            visible={selectCouponModal}
            submitting={submitting}
            close={() => setSelectCouponModal(false)}
            submit={updateCoupon}
            newCouponAdd={newCouponAdd}
          />
          )}

          {/* ADD COUPON MODAL */}
          {addCouponModal && (
          <AddCoupon
            visible={addCouponModal}
            submitting={submitting}
            close={() => setAddCouponModal(false)}
            submit={addCoupon}
            selectedAccount={selectedAccount}
            allCustomers={customerResult}
            fetchCustomer={fetchCustomer}
          />
          )}

          {/* SELECT TAXRATE MODAL */}
          {selectTaxrateModal && (
          <SelectTaxrate
            visible={selectTaxrateModal}
            submitting={submitting}
            close={() => setSelectTaxrateModal(false)}
            submit={updateTaxrate}
            newTaxAdd={newTaxAdd}
          />
          )}

          {/* ADD TAX MODAL */}
          {addTaxModal && (
          <AddTaxrate
            visible={addTaxModal}
            submitting={submitting}
            close={() => setAddTaxModal(false)}
            submit={addTaxrate}
            selectedAccount={selectedAccount}
            allTaxes={allTaxes}
            fetchTaxDetails={fetchTaxDetails}
          />
          )}

          {/* SELECT SHIPPINFEE MODAL */}
          {selectShippingFeeModal && (
          <SelectShippingFee
            visible={selectShippingFeeModal}
            submitting={submitting}
            close={() => setSelectedShippingFeeModal(false)}
            submit={updateShippingFee}
            prefix={prefix}
          />
          )}

          {/* ADD PRODUCT MODAL */}
          {addProductModal && (
          <AddNewProduct
            visible={addProductModal}
            submitting={submitting}
            supportedCurrency={supportedCurrency}
            close={() => setAddProductModal(false)}
            submit={addNewProduct}
            selectedAccount={selectedAccount}
          />
          )}

          {addItemModal && (
          <AddItem
            visible={addItemModal}
            submitting={submitting}
            itemsList={itemsList && itemsList}
            modifierItemsList={modifierItemsList && modifierItemsList}
            labelList={labelList && labelList}
            selectedAccount={selectedAccount}
            close={() => setAddItemModal(false)}
            submit={addSelectedItem}
          />
          )}

        </Card>
      ) : (
        <Card>
          <Row className="my-2">
            <div className="d-flex justify-content-end">
              <RBAC permit={[ROLES.OWNER, ROLES.ADMINISTRATOR, ROLES.DEVELOPER, ROLES.OFFICEMANAGER, ROLES.OFFICESUPPORT,
                ROLES.OPERATIONS, ROLES.SUPERUSER, ROLES.INTERNALSUPPORT, ROLES.ONBOARDING]}
              >
                <Col>
                  <SpButton
                    type="secondary"
                    shape="round"
                    className="mr-3"
                    ghost
                    onClick={() => setAddPlansModal(true)}
                  >
                    {'\u002B'}&nbsp;Add Plan
                  </SpButton>
                  <span>
                    {
                  exportData !== null
                    ? (
                      <Tooltip placement="left" title="Click here to export Plans">
                        <CSVLink
                          target="_blank"
                          className="mr-3"
                          filename="Plans Report.csv"
                          data={exportData}
                          headers={exportHeaders}
                          onMouseEnter={() => setFillColor(true)}
                          onMouseLeave={() => setFillColor(false)}
                        >
                          <ExportIcon
                            fill={fillColor
                              ? '#279dfe'
                              : '#C0C0C0'}
                          />
                        </CSVLink>
                      </Tooltip>
                    ) : null
                }
                  </span>
                  <span ref={myRef}>
                    <span
                      onClick={() => setOpen(!open)}
                      style={{ cursor: 'pointer' }}
                      onMouseEnter={() => setFilterColor(true)}
                      onMouseLeave={() => setFilterColor(false)}
                    >
                      {open && (
                      <Badge count={count} style={{ backgroundColor: '#0090ff' }}>
                        <FilterIcon
                          fill={filterColor
                            ? '#279dfe'
                            : '#C0C0C0'}
                        />
                      </Badge>
                      )}
                      {!open && (
                      <Tooltip placement="left" title="Click here to filter Plans">
                        <Badge count={count} style={{ backgroundColor: '#0090ff' }}>
                          <FilterIcon
                            fill={filterColor
                              ? '#279dfe'
                              : '#C0C0C0'}
                          />
                        </Badge>
                      </Tooltip>
                      )}
                    </span>
                    {open && (
                    <FilterWrapper
                      style={{ marginLeft: '-144px' }}
                    >
                      <Filters
                        filtersGrid={filterPlans}
                        filterTypes={filterTypes}
                        handleChange={handleChange}
                        onCheck={onCheck}
                        fiterOperators={fiterOperators}
                        handleOperator={handleOperator}
                        handleValue={handleValue}
                        startDate={startDate}
                        endDate={endDate}
                        currentDate={currentDate}
                        handleFromValue={handleFromValue}
                        handleToValue={handleToValue}
                      />
                      <div className="px-4 mt-2">
                        {
                        filterPlans.length < PLAN_FILTERS_TYPES.length && (
                          <div className="mb-2 ml-3" style={{ cursor: 'pointer' }}>
                            <SpText
                              fontWeight="600"
                              color="#279dfe"
                              onClick={handleAddClick}
                            >
                              +&nbsp; Add another filter
                            </SpText>
                          </div>
                        )
                      }
                      </div>
                      <div className="d-flex mb-2 justify-content-end mr-3">
                        <SpButton
                          type="secondary"
                          shape="round"
                          className="mr-2"
                          ghost
                          onClick={resetFilters}
                        >
                          Clear
                        </SpButton>
                        <SpButton
                          type="primary"
                          shape="round"
                          onClick={applyFilters}
                        >
                          Save
                        </SpButton>
                      </div>
                    </FilterWrapper>
                    )}
                  </span>
                </Col>
              </RBAC>
            </div>
          </Row>
          <Table
            onRow={(record) => ({
              onClick: () => {
                selectedRecord(record);
              },
            })}
            rowClassName={() => 'ant-table-clickable-row'}
            columns={[...columns]}
            rowKey={(record) => record.gid}
            dataSource={plans}
            pagination={pagination}
            onChange={handleTableChange}
          />
        </Card>
      )
    }
    </>
  );
};

const mapStateToProps = (state) => ({
  plans: state.planv2.content,
  totalElements: state.planv2.totalElements,
  loading: state.loading.loading,
  validator: state.loading.validator,
  submitting: state.loading.submitting,
  test: state.account.test,
  selectedAccount: state.account.selectedAccount,
  isSuperUser: state.user.superUser,
  preserveFilters: state.filterParams.preserveFilters,
  productsList: state.invoiceDetails.productsList,
  inventoryItems: state.inventoryItems.content,
  customerResult: state.invoiceDetails.customersList,
  newTaxrate: state.invoiceDetails.newTaxrate,
  taxList: state.invoiceDetails.taxList,
  modifierItemsList: state.inventoryItems.modifierItemsList.content,
  itemsList: state.inventoryItems.itemsList.content,
  labelList: state.inventoryPrinterLabel.labelList.content,
  addedNewProduct: state.invoiceDetails.newProduct,
  addedNewItem: state.inventoryItems.addedItem.entity,
});

const mapDispatchToProps = (dispatch) => ({
  fetchPlanV2: param => dispatch(planv2Actions.fetchPlanV2({
    payload: param,
  })),
  addPlanV2: param => dispatch(planv2Actions.addPlanV2({
    payload: param,
  })),
  setFilterData: (value) => dispatch(filterParamsActions.setFilterData({
    type: FILTERS_SPECS.SET_FILTER_DATA,
    payload: value,
  })),
  getProductsList: param => dispatch(invoiceDetailsAction.getProductsList({
    payload: param,
  })),
  fetchInventoryItems: param => dispatch(inventoryItemsActions.fetchInventoryItems({
    payload: param,
  })),
  addNewCoupon: param => dispatch(invoiceDetailsAction.addNewCoupon({
    payload: param,
  })),
  getCustomersList: param => dispatch(invoiceDetailsAction.getCustomersList({
    payload: param,
  })),
  addNewTaxRate: param => dispatch(invoiceDetailsAction.addNewTaxRate({
    payload: param,
  })),
  getTaxes: param => dispatch(invoiceDetailsAction.getTaxes({
    payload: param,
  })),
  addNewProcut: param => dispatch(invoiceDetailsAction.addNewProcut({
    payload: param,
  })),
  fetchItemsList: param => dispatch(inventoryItemsActions.fetchItemsList({
    payload: param,
  })),
  fetchModifierItemsList: param => dispatch(inventoryItemsActions.fetchModifierItemsList({
    payload: param,
  })),
  fetchPrinterLabelList: (payload) => dispatch(inventoryPrinterLabelActions.fetchPrinterLabelList({
    payload,
  })),
  addInventoryItems: param => dispatch(inventoryItemsActions.addInventoryItems({
    payload: param,
  })),
});

// $FlowFixMe
export default connect(mapStateToProps, mapDispatchToProps)(Plans);
